// The notification surface: the bell in the top bar and the red dots in the sidebar.
// Owns the top-level `alerts` key and nothing else.
//
// It carries its own words for "באיחור" / "להיום" rather than reaching into he.board,
// following what money.js and dashboard.js already do with the same word: each area
// phrases its own labels, and the parts never import one another (see he.js).
const alerts = {
  alerts: {
    // The bell itself.
    bell: 'התראות',
    title: 'הגיע זמנן',
    // Deliberately says what the bell DOESN'T include. It counts scheduled tasks whose
    // date has arrived — not open invoices, which have their own mark on כספים. A bell
    // that lit up for every unpaid invoice would never go dark, and a notification that
    // is always on is one you stop reading.
    empty: 'אין משימות להיום',
    overdue: 'באיחור',
    dueToday: 'להיום',
    // n is always ≥ 1 — the summary line is not rendered at all for an empty bell.
    countOverdue: (n) => (n === 1 ? 'משימה אחת באיחור' : `${n} משימות באיחור`),
    countToday: (n) => (n === 1 ? 'משימה אחת להיום' : `${n} משימות להיום`),
    // The orphan case, and the one thing the bell shows that no page can. A task on a
    // ליד אבוד or on a deactivated client belongs to neither board — the work board
    // lists active customers, the pipeline lists live leads — so this is the only place
    // it is reachable from. Said plainly on the row instead of letting it look like an
    // ordinary one.
    noBoard: 'לא מופיעה בשום לוח',
    noBoardHint: 'הלקוח אינו לקוח פעיל ואינו ליד בתהליך, ולכן המשימה אינה מופיעה בלוח המשימות ולא בלידים — רק כאן ובכרטיס הלקוח.',
    goClient: 'לכרטיס הלקוח',
    goBoard: 'ללוח המשימות',
    goLeads: 'ללידים',
    // ── שתי המחלקות בפעמון ─────────────────────────────────────────────────────────
    // משימה היא משהו להפיק; חזרה לליד היא מעקב קשר. שתי רשימות נפרדות, בשתי שפות —
    // אותו פעמון, אבל לא אותו סוג של דבר, ולכן לא רשימה אחת מעורבת.
    sectionTasks: 'משימות',
    sectionLeads: 'לידים לחזרה',
    // The prefix that makes a lead row read as a lead: "ליד לחזרה: דוד כהן".
    leadPrefix: 'ליד לחזרה',
    leadCountOverdue: (n) => (n === 1 ? 'ליד אחד באיחור' : `${n} לידים באיחור`),
    leadCountToday: (n) => (n === 1 ? 'ליד אחד להיום' : `${n} לידים להיום`),
    // The last thing said, shown on the row — what was agreed, at the moment you are
    // about to pick up the phone.
    lastContact: 'שיחה אחרונה',
    noContactYet: 'עדיין לא תועדה שיחה',
    goLead: 'למסך הלידים',

    // The sidebar dots. Titles only — the dot itself has no text.
    dotOverdue: 'יש פריטים באיחור',
    dotToday: 'יש פריטים להיום',
    dotMoneyWaiting: 'יש כסף שממתין לתשלום',
    // The money item's amber has no "today" in it: it means work is waiting there — the
    // same words the money screen's headline uses for the same two counts.
    dotMoneyToDo: 'יש חיובים שצריך להוציא',
    dotMoney: 'יש חשבוניות באיחור',
  },
};

export default alerts;
